<template>
  <div id="app">
    <navbar></navbar>
    <div class="app-content">
      <router-view/>
    </div>
  </div>
</template>

<script>
import navbar from './components/navbar.vue';
export default {
  name: 'HomeView',
  components: {
    navbar
  }
}
</script>


<style lang="scss">
@import '@/assets/global.scss';

html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.app-content {
  height: calc(100vh - 52px);
  background: var(--bg-page);
}
</style>
